<div
  [ngClass]="{'toast-over': toastMessage && toastMessage.cover, 'complete': isComplete}"
  [@showOver]="toastOver ? transitions.ShowOver : ''"
  (@showOver.done)="hideOverToast($event)">
  <div [ngClass]="{'toast-left': placement==='left', 'toast-right': placement==='right'}">
    <span
      class="toaster"
      *ngIf="placement==='left'">
      <span
        class="toast"
        *ngIf="toastMessage"
        [@showLeft]="toastLeft ? transitions.ShowLeft : ''"
        (@showLeft.done)="hideInlineToast($event)">
        <ng-template [ngTemplateOutlet]="toastMessageTemplate"></ng-template>
      </span>
    </span>
    <span class="inner-content">
        <ng-content></ng-content>
    </span>
    <span
      class="toaster"
      *ngIf="placement==='right'">
      <span
        class="toast"
        *ngIf="toastMessage"
        [@showRight]="toastRight ? transitions.ShowRight : ''"
        (@showRight.done)="hideInlineToast($event)">
        <ng-template [ngTemplateOutlet]="toastMessageTemplate"></ng-template>
      </span>
    </span>
  </div>
</div>
<ng-template #toastMessageTemplate>
  <span
    class="toast-content"
    [ngClass]="(toastMessage.type === 'error') ? 'error' : 'success'">
    <span class="toast-icon" *ngIf="toastMessage.type === 'error'; else successIcon">
      <capra-icon icon="icon-info-outline"></capra-icon>
    </span>
    <span class="toast-message">{{toastMessage.message}}</span>
  </span>
</ng-template>
<ng-template #successIcon>
  <capra-icon icon="icon-check-outline"></capra-icon>
</ng-template>
